import api from ".."

const onboardApi = api.injectEndpoints({
  endpoints: (build) => ({
    getOnboardedInvestors: build.query({
      query: () => ({
        url: `/wealthPartner/onboard/list`,
        method: "GET",
      }),
    }),
    onboardedInvestor: build.mutation({
      query: (body) => ({
        url: `/wealthPartner/onboard/create`,
        method: "POST",
        body,
      }),
    }),
    deleteOnboardedInvestor: build.mutation({
      query: ({ id }) => ({
        url: `/wealthPartner/onboard/delete/${id}`,
        method: "DELETE",
      }),
    }),
    getOnboardedInvestorDetails: build.query({
      query: ({ id }) => ({
        url: `/wealthPartner/onboard/details/${id}`,
        method: "GET",
      }),
    }),
    getOnboardedInvestorDetails: build.query({
      query: ({ id }) => ({
        url: `/wealthPartner/onboard/details/${id}`,
        method: "GET",
      }),
    }),
    saveOnboardedBusinessDetails: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboard/save_company_details/${id}`,
        method: "POST",
        body,
      }),
    }),
    saveOnboardedBusinessDetailsManually: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboard/company_details/manually/${id}`,
        method: "POST",
        body,
      }),
    }),
    updateInvestorOnboardedStep: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboard/update/step/${id}`,
        method: "POST",
        body,
      }),
    }),
    storeBusinessAdditionalDetailsOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboard/business_additional_details/${id}`,
        method: "POST",
        body,
      }),
    }),

    updateBankDetailsOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboard/update/bank/details/${id}`,
        method: "POST",
        body,
      }),
    }),
    fetchBankDetailsOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboard/bank/fetch/${id}`,
        method: "POST",
        body,
      }),
    }),
    updateBusinessSignatoryOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboard/update/business/signatory/${id}`,
        method: "POST",
        body,
      }),
    }),
    uploadAuthorityLetterOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboard/upload/authority/letter/${id}`,
        method: "POST",
        body,
      }),
    }),
    updateIcdAgreementOnboardedInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboard/update/icd/agreement/${id}`,
        method: "POST",
        body,
      }),
    }),
    completeOnboardingInvestor: build.mutation({
      query: ({ id, ...body }) => ({
        url: `/wealthPartner/onboard/final/submission/${id}`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useLazyGetOnboardedInvestorsQuery,
  useOnboardedInvestorMutation,
  useDeleteOnboardedInvestorMutation,
  useLazyGetOnboardedInvestorDetailsQuery,
  useSaveOnboardedBusinessDetailsMutation,
  useSaveOnboardedBusinessDetailsManuallyMutation,
  useUpdateInvestorOnboardedStepMutation,
  useStoreBusinessAdditionalDetailsOnboardedInvestorMutation,
  useUpdateBankDetailsOnboardedInvestorMutation,
  useFetchBankDetailsOnboardedInvestorMutation,
  useUpdateBusinessSignatoryOnboardedInvestorMutation,
  useUploadAuthorityLetterOnboardedInvestorMutation,
  useUpdateIcdAgreementOnboardedInvestorMutation,
  useCompleteOnboardingInvestorMutation,
} = onboardApi
